// PreflightBandi — Anne Defteri'nin tepesinde duran durum bandı (CR2-11).
// Anomali var iken: warn (turuncu, "anneye göstermeden önce inceleyin").
// Anomali yok iken: calm (mor/lacivert, "anneye gösterilebilir").
//
// Geçiş: bg + border + text rengi 280ms ease ile yumuşar (styles.css'te
// global "preflight-band" sınıfı eklenmemiş — burada inline transition class
// kullanıyoruz; Tailwind transition-colors yeterli).

import { useNavigate } from "react-router-dom";

interface Props {
  openAnomaliesCount: number;
}

export default function PreflightBandi({ openAnomaliesCount }: Props) {
  const navigate = useNavigate();
  const hasOpen = openAnomaliesCount > 0;

  if (hasOpen) {
    return (
      <div
        role="status"
        aria-live="polite"
        className="rounded-xl border px-3 py-2.5 flex items-center gap-2.5 transition-colors duration-300 bg-warn-500/10 border-warn-500/30"
      >
        <span
          aria-hidden="true"
          className="inline-flex items-center justify-center w-7 h-7 rounded-full shrink-0 bg-warn-500/20 text-warn-400"
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0zM12 9v4M12 17h.01" />
          </svg>
        </span>
        <div className="grow min-w-0">
          <p className="text-[12px] font-semibold leading-tight text-warn-400">
            {openAnomaliesCount} anomali açık
          </p>
          <p className="text-[11px] mt-0.5 leading-tight text-ink-300">
            Anneye göstermeden önce inceleyin.
          </p>
        </div>
        <button
          type="button"
          onClick={() => navigate("/anomaliler")}
          className="text-[12px] font-medium px-2 py-1 rounded shrink-0 bg-warn-500/20 text-warn-400 hover:bg-warn-500/30 transition-colors"
        >
          İncele →
        </button>
      </div>
    );
  }

  return (
    <div
      role="status"
      aria-live="polite"
      className="rounded-xl border px-3 py-2.5 flex items-center gap-2.5 transition-colors duration-300 bg-calm-500/10 border-calm-500/30"
    >
      <span
        aria-hidden="true"
        className="inline-flex items-center justify-center w-7 h-7 rounded-full shrink-0 bg-calm-500/20 text-calm-400"
      >
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polyline points="20 6 9 17 4 12" />
        </svg>
      </span>
      <div className="grow min-w-0">
        <p className="text-[12px] font-semibold leading-tight text-calm-400">
          Tüm anomaliler temiz
        </p>
        <p className="text-[11px] mt-0.5 leading-tight text-ink-300">
          Anneye gösterilebilir.
        </p>
      </div>
    </div>
  );
}
